import userTypes from './user.types';

export const INITIAL_STATE = {
  profile: {
    fullName: '',
    email: '',
    packageType: '',
    mobile: '',
    remainingConversations: '',
    convsArchiveRange: '',
    remainingDaysNum: '',
    remainingDays: '',
    image: '',
    accessLevel: '',
    accountType: '',
    isLoggedIn: false,
    isCreatorAdmin: false,
    isFetching: true,
    data: null,
    error: null,
  },
};

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case userTypes.SET_CURRENT_USER:
      return {
        ...state,
        profile: {
          ...state.profile,
          ...action.payload,
        },
      };
    case userTypes.SET_USER_CREDENTIALS_ERRORS:
      return {
        ...state,
        credentialsErrors: action.payload,
      };
    case userTypes.POST_USER_DATA_OF_OTV_SUCCESS:
      return {
        ...state,
        isFetching: false,
        data: action.payload,
      };
    case userTypes.POST_USER_DATA_OF_OTV_FAILURE:
      return {
        ...state,
        isFetching: false,
        data: action.payload.data,
      };
    default:
      return state;
  }
};

export default userReducer;
